<template>
  <section id="vision-values" class="o-section c-vision" v-my-section-class>

    <!-- Background -->
    <div class="o-background">
      <div class="o-background__inner">
        <transition name="quick-fade">
          <div class="o-background__group o-background__group--vision" key="vision" v-if="tabIndex === 0 && $store.state.device !== 0">
            <my-circle class="o-background__item o-background__item--1" :variant="2"></my-circle>
          </div>
          <div class="o-background__group o-background__group--values" key="values" v-if="tabIndex === 1">
            <div class="o-background__helix"></div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">Our vision and values</h2>

      <my-tabs @tab-changed="setTabIndex">
        <my-tab title="Our vision" :is-active="true">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">To be the best performing distribution network operator in the UK from 2015/16 to 2018/19</h3>
              <p class="o-panel__subtitle">We will achieve this by demonstrating industry leadership in the three areas below:</p>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--3">
                <div class="o-grid__item" v-for="(item, index) in visionItems">
                  <div class="c-vision__kpi">
                    <div class="o-kpi--circle" :class="['o-kpi--circle--' + circleColors[index]]">
                      <div class="o-kpi--circle__inner">
                        <p class="o-kpi--circle__text">{{ item.title }}</p>
                      </div>
                    </div>
                  </div>
                  <div v-html="item.body" class="o-list__wrapper"></div>
                </div>

              </div>
            </div>
          </my-tab-inner>
        </my-tab>
        <my-tab title="Our values" class="c-vision__values">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">The DNA of our business</h3>
              <p class="o-panel__subtitle">Our values communicate the behaviour we expect of our staff and our contractors. They form the basis of the way we do business.</p>
            </div>
            <div class="o-panel__body o-panel__body--full">

              <div class="o-grid o-grid--2">
                <div class="o-grid__item" v-for="(item, index) in valueItems">
                  <h3>{{ item.title }}</h3>
                  <div v-html="item.body"></div>
                </div>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import { MySectionClass } from '@/directives/my-section-class.js'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import MyCircle from '@/components/standard/my-circle'
import mixins from '@/mixins'

export default {
  name: 'my-vision',
  components: {
    MyTabs,
    MyTab,
    MyTabInner,
    MyCircle
  },
  directives: {
    MySectionClass
  },
  mixins: [mixins],
  data () {
    return {
      circleColors: ['orange', 'red', 'grey']
    }
  },
  computed: {
    visionItems () {
      return this.$store.state.content['vision'] || []
    },
    valueItems () {
      return this.$store.state.content['values'] || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyVision.vue?582d774c